import {
  phoneService
} from '../_services';

// importamos las traducciones para gestionar los avisos
import i18n from '../i18n.js';

const state = {

  phones: null,
  loading: false,
  error: null,
  currentEditPhone: null

}

const actions = {

  createUserPhone({
    dispatch,
    commit
  }, objPhone) {

    commit('statusLoading', true);

    phoneService.createUserPhone(objPhone)
      .then(
        data => {
          commit('createPhoneOk', data);
          dispatch('notifier/success', i18n.t('notifier_created_phone_ok'), {
            root: true
          });
          dispatch('account/refreshUserData', true, {
            root: true
          });
        },
        error => {
          commit('createPhoneKo', error);
          dispatch('notifier/error', error, {
            root: true
          })
        }
      )
  },

  updateUserPhone({
    dispatch,
    commit
  }, objPhone) {

    commit('statusLoading', true);
    return new Promise((resolve, reject) => {

      phoneService.updateUserPhone(objPhone)
        .then(
          data => {
            commit('updatePhoneOk', data);
            dispatch('notifier/success', i18n.t('notifier_updated_phone_ok'), {
              root: true
            });
            dispatch('account/refreshUserData', true, {
              root: true
            });
            return resolve(true);
          },
          error => {
            commit('updatePhoneKo', error);
            dispatch('notifier/error', error, {
              root: true
            })
          }
        )

    })


  },

  deleteUserPhone({
    dispatch,
    commit
  }, idPhone) {

    commit('statusLoading', true);
    return new Promise((resolve, reject) => {

      phoneService.deleteUserPhone(idPhone)
        .then(
          data => {
            commit('deletePhoneOk', data);
            dispatch('notifier/success', i18n.t('notifier_deleted_phone_ok'), {
              root: true
            });
            return resolve(true)
          },
          error => {
            commit('deletePhoneKo', error);
            dispatch('notifier/error', error, {
              root: true
            });
          }
        )
    })

  },

  /*   getUserAddressById({
      commit
    }, addressId) {

      commit('statusLoading', true);  


      addressService.getUserAddress(addressId)
        .then(
          data => {        
            commit('getUserAddressByIdOk', data.data);
            dispatch('notifier/success', i18n.t("recuperados_datos_correctamente"), {
              root: true
            });
          },
          error => {
            commit('getUserAddressByIdKo', error);
             dispatch('notifier/error', error, {
              root: true
            }); 
          }
        )
    } */
};


const mutations = {

  statusLoading(state, status) {
    state.loading = status;
  },
  createPhoneOk(state, phone) {
    state.currentEditPhone = phone;
    state.loading = false;
  },
  createPhoneKo(state, error) {
    state.currentEditPhone = null;
    state.error = error;
    state.loading = false;
  },
  updatePhoneOk(state, phone) {
    state.currentEditPhone = phone;
    state.loading = false;
  },
  updatePhoneKo(state, error) {
    state.error = error;
    state.loading = false;
  },
  deletePhoneOk(state, phone) {
    state.currentEditPhone = phone;
    state.loading = false;
  },
  deletePhoneKo(state, error) {
    state.error = error;
    state.loading = false;
  },
  getUserPhoneByIdOk(state, phone) {
    state.currentEditPhone = phone;
    state.loading = false;
  },
  getUserPhoneByIdKo(state, error) {
    state.error = error;
    state.loading = false;
  },

};

export const phone = {
  namespaced: true,
  state,
  actions,
  mutations
}